import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/claims/$claimId/')({
  component: () => <Navigate replace search from="/bak/claims/$claimId/" to="/bo/claims/$claimId" />,
})
